import React from 'react';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import {ModifiedNucleotides} from 'biojs/Sequence';
import {TranslationAttributes} from 'biojs/Translation';
import DataConnector from 'connect/DataConnector';
import {WorkspaceItem} from 'constants/NavConstants';
import {Tag} from 'folder-items/FileConstants';
import * as BioentityActions from 'inventory/BioentityActions';
import WorkspaceStore from 'sidebar/WorkspaceStore';
import APIUtil from 'util/APIUtil';

interface ConnectedProps {
  visibleBioentityIds: Array<string>;
}
interface ValidationStateFetcherProps {
  proteinResidues?: string | null;
  registryId?: string | null;
  sequenceBases?: string | null;
  sequenceCircular?: boolean | null;
  sequenceModifiedNucleotides?: ModifiedNucleotides | null;
  sequenceParts: Array<Object>;
  sequenceTranslations: Array<TranslationAttributes>;
  tags: Array<Tag>;
}

class ValidationStateFetcherConnector extends DataConnector<ValidationStateFetcherProps, ConnectedProps> {
  stores = [WorkspaceStore];
  shouldSubscribeToRedux = false;

  enhanceProps(): ConnectedProps {
    const workspaceItems: Array<WorkspaceItem> = this.workspaceStore().getState().workspaceItems;
    const visibleItems = workspaceItems.slice(0, this.workspaceStore().getMaxOverheadTabs());
    const visibleBioentities = visibleItems.filter((item) => APIUtil.isBiologicalEntity(item.fileId));
    return {
      // eslint-disable-next-line no-restricted-syntax
      visibleBioentityIds: _.pluck(visibleBioentities, 'fileId'),
    };
  }
}

/**
 * Unrendered component that listens for changes to an entity's attributes that affect validation state,
 * and fetches for validation state when that happens.
 *
 * Fetches state for all visible workspace items (whose tabs are not in the overflow) because validation state
 * affects rendering workspace tabs.
 */
export class ValidationStateFetcher extends React.PureComponent<
  ValidationStateFetcherProps & ConnectedProps
> {
  componentDidMount(): void {
    this._fetch();
  }

  componentDidUpdate(prevProps: ValidationStateFetcherProps & ConnectedProps): void {
    if (
      !isEqual(prevProps.proteinResidues, this.props.proteinResidues) ||
      !isEqual(prevProps.sequenceBases, this.props.sequenceBases) ||
      !isEqual(prevProps.sequenceCircular, this.props.sequenceCircular) ||
      !isEqual(prevProps.sequenceModifiedNucleotides, this.props.sequenceModifiedNucleotides) ||
      !isEqual(prevProps.sequenceParts, this.props.sequenceParts) ||
      !isEqual(prevProps.sequenceTranslations, this.props.sequenceTranslations) ||
      !isEqual(prevProps.tags, this.props.tags) ||
      !isEqual(prevProps.registryId, this.props.registryId)
    ) {
      this._fetch();
    }
  }

  _fetch(): void {
    BioentityActions.pollValidationState(this.props.visibleBioentityIds);
  }

  render(): null {
    return null;
  }
}

export default ValidationStateFetcherConnector.connect(ValidationStateFetcher);
